import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import axios from 'axios';
import Translator from '../../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../../routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';
import AppSpinner from '../../../../../components/AppSpinner';
import colors from '../../../../../../constants/colors';
import { path } from '@/routing/helpers/router';

export default function Plant({ elementID }) {
  const dispatch = useDispatch();
  const global = useSelector((state) => state.global);
  const resLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID],
  );
  const resLevel2 = useSelector(
    (state) => state.currentPage?.elementLevels?.level2?.[elementID],
  );
  const [isLoading, setIsLoading] = useState(false);

  // > REDIRECT TO PLANT WITH OBLIGATION FILTER
  const createFilterAndRedirect = useCallback(async () => {
    setIsLoading(true);

    return axios
      .post(
        axiosPath(
          'api_r_user_module_resourceManager_generateFilterHexCodeWithObligationIDs',
        ),
        {
          moduleBridgeHex: resLevel2?.plant?.moduleBridgeHex,
          resourceID: resLevel1?.id,
        },
      )
      .then(({ data }) => {
        if (data?.hexCode) {
          window.open(
            path({
              name: 'user_module_legalCompliance_evaluation',
              params: {
                moduleBridgeHex: resLevel2?.plant?.moduleBridgeHex,
                plantHex: resLevel2?.plant?.plantHex,
                page: 1,
                filtersHex: data?.hexCode,
              },
            }),
          );
          // window.open(
          //   `${global.urlData.rootProject}r/legal-compliance/${resLevel2?.plant?.moduleBridgeHex}/evaluation/${resLevel2?.plant?.plantHex}/1/${data?.hexCode}/`,
          //   '_blank',
          // );
        }
      })
      .catch((e) => dispatch(errorHandler(e)))
      .finally(() => setIsLoading(false));
  }, [global, resLevel1, resLevel2]);
  // < REDIRECT TO PLANT WITH OBLIGATION FILTER

  return (
    <>
      {resLevel2?.plant ? (
        <>
          {isLoading ? (
            <AppSpinner>
              <AppRemixIcon
                icon="loader-4"
                color={colors.primaryLight}
                size={13}
              />
            </AppSpinner>
          ) : (
            <span className="pointer" onClick={createFilterAndRedirect}>
              <AppRemixIcon
                icon="building-4"
                color={colors.primary}
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-resourceManager"
                    name="resource.relationship.installation.plantname.module.modulename"
                    variables={{
                      plantName: resLevel2?.plant?.plantName,
                      moduleName: resLevel2?.plant?.moduleName,
                    }}
                  />,
                )}
              />
            </span>
          )}
        </>
      ) : (
        <AppRemixIcon
          icon="building-4"
          color={colors.grey400}
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-resourceManager"
              name="resource.no.connection.installationame"
            />,
          )}
        />
      )}
    </>
  );
}
